const state = {
  client_list: [],
  client_selected: undefined,
  current_network: undefined
}

export default state



//////////////////
// WEBPACK FOOTER
// ./state/client/client.state.js
// module id = null
// module chunks = 